import usePaymentDrawTonightLifeCycle from "./usePaymentDrawTonightLifeCycle";
import usePaymentDrawTonightInterface from "./usePaymentDrawTonightInterface";

const usePaymentDrawTonightProvider = () => {
  usePaymentDrawTonightLifeCycle();
  usePaymentDrawTonightInterface();
};

export default usePaymentDrawTonightProvider;
